import { motion, AnimatePresence } from 'framer-motion';
import { NewVersionNotificationProps } from './types';

export const NewVersionNotification: React.FC<NewVersionNotificationProps> = ({
    title = "What's New!",
    message = "We've made some exciting updates to improve your experience.",
    whatsNew,
    onDismiss,
}) => {
    return (
        <AnimatePresence>
            <motion.div
                className="fixed inset-0 bg-primary-50 bg-opacity-70 flex items-center justify-center"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
            >
                <motion.div
                    className="bg-white text-primary-900 p-6 rounded-lg shadow-lg text-center"
                    initial={{ scale: 0.8 }}
                    animate={{ scale: 1 }}
                    exit={{ scale: 0.8 }}
                    transition={{ duration: 0.5 }}
                >
                    <h1 className="text-4xl text-surface-high font-bold mb-4">{title}</h1>
                    <p className="text-xl text-surface-medium">{message}</p>
                    {whatsNew.map((item) => (
                        <div key={item.id} className="text-surface-high mb-4 p-4 border-b border-gray-200 text-start">
                            {item.imageUrl && (
                                <img
                                    src={item.imageUrl}
                                    alt={item.title}
                                    className="w-full h-auto rounded shadow-md mb-4"
                                />
                            )}
                            <h2 className="text-2xl font-bold">{item.title}</h2>
                            <p className="text-lg text-gray-700">{item.description}</p>
                            <small className="block mb-2 text-gray-500">{item.date}</small>
                        </div>
                    ))}
                    <button
                        onClick={onDismiss}
                        className="mt-4 px-4 py-2 bg-primary text-white rounded transition hover:bg-primary-700 focus:outline-none"
                    >
                        Dismiss
                    </button>
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
};
